<template>
  <v-container fluid>
    <div>
      <!-- ヘッダー -->
      <v-row>
        <v-col cols="12">
          <h2>
            <v-icon class="mr-2">
              mdi-home-city-outline
            </v-icon>
            契約情報
          </h2>
          <v-spacer class="mt-2" />
        </v-col>
      </v-row>
      <v-row v-if="external_error">
        <v-col>
          <v-alert
            border="bottom"
            outlined
            text
            type="error"
          >
            <template v-if="['company_unselected'].includes(external_error)">
              freeeの事業所が未選択です。freeeとの連携を行う場合は事業所を選択してください。
            </template>
            <template v-if="['not_acceptable'].includes(external_error)">
              許可されていません。
            </template>
            <template v-if="['none_params', 'state_mismatch', 'unauthorized'].includes(external_error)">
              freeeとの連携に失敗しました。「設定する」をクリックし再度連携を行ってください。
            </template>
            <template v-if="['access_denied'].includes(external_error)">
              freeeとの連携を行う場合は、freee側で「許可する」を選択してください。
            </template>
            <template v-if="['no_company'].includes(external_error)">
              freeeのアカウントに事業所が設定されていません。freeeのアカウントをご確認の上再度連携を行ってください。
            </template>
          </v-alert>
        </v-col>
      </v-row>
      <!-- /ヘッダー -->
      <v-card
        v-if="tenant"
        flat
        class="rounded-card"
      >
        <v-card-text>
          <v-card flat class="rounded-card">
            <v-card-title>法人詳細</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    法人コード
                  </div>
                  <h4>{{ contractor.code }}</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    法人名
                  </div>
                  <h4>{{ contractor.name }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    法人名フリガナ
                  </div>
                  <h4>{{ contractor.name_kana }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <div class="overline">
                    住所
                  </div>
                  <h4>〒{{ contractor.zip_code }}&nbsp;{{ contractor.address }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    代表者名
                  </div>
                  <h4>{{ contractor.representative_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    代表者名フリガナ
                  </div>
                  <h4>{{ contractor.representative_name_kana }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    担当者名
                  </div>
                  <h4>{{ contractor.supervisor_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    担当者名フリガナ
                  </div>
                  <h4>{{ contractor.supervisor_name_kana }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    申込担当者部署名
                  </div>
                  <h4>{{ contractor.supervisor_department_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    申込担当者電話番号
                  </div>
                  <h4>{{ contractor.supervisor_phone_number }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    申込担当者FAX番号
                  </div>
                  <h4>{{ contractor.supervisor_fax_number }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    申込担当者メールアドレス
                  </div>
                  <h4>{{ contractor.supervisor_email }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    パスワード有効期限
                  </div>
                  <h4>{{ contractor.password_valid_day_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    WEBアクセストークン有効期限
                  </div>
                  <h4>{{ contractor.web_access_token_valid_time_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    アプリアクセストークン有効期限
                  </div>
                  <h4>{{ contractor.app_access_token_valid_time_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="my-4" :thickness="2" color="light-blue lighten-5"></v-divider>
            <v-card-title>支店/営業所詳細</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    支店/営業所コード
                  </div>
                  <h4>{{ tenant.code }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    支店/営業所名
                  </div>
                  <h4>{{ tenant.name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    支店/営業所名フリガナ
                  </div>
                  <h4>{{ tenant.name_kana }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <v-card-subtitle>{{ tenant.mode_name === '処分のみ' ? '代表処分加入者' : '収運加入者' }}</v-card-subtitle>
              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    加入者番号
                  </div>
                  <h4>{{ tenant.subscriber_number }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    公開確認番号
                  </div>
                  <h4>{{ tenant.confirmation_number }}</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    EDI利用確認キー
                  </div>
                  <h4>{{ tenant.edi_usage_key }}</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <br />
              <template>
                <v-card
                v-if="tenant.mode_name === '収運・処分' || tenant.mode_name === '処分のみ'"
                  outlined
                  style="max-height: 30vh;overflow-y: scroll;"
                >
                  <v-card-subtitle>処分加入者</v-card-subtitle>
                  <template
                    v-for="disposal in tenant.disposal_subscribers_attributes"
                  >
                    <v-card-text
                      v-if="!disposal._destroy"
                      :key="disposal.key"
                    >
                      <v-row
                        dense
                      >
                        <v-col cols="12" md="3">
                          <div class="overline">
                            加入者番号
                          </div>
                          <h4>{{ disposal.subscriber_number }}</h4>
                          <v-divider />
                        </v-col>
                        <v-col cols="12" md="3">
                          <div class="overline">
                            公開確認番号
                          </div>
                          <h4>{{ disposal.confirmation_number }}</h4>
                          <v-divider />
                        </v-col>
                        <v-col cols="12" md="3">
                          <div class="overline">
                            EDI利用確認キー
                          </div>
                          <h4>{{ disposal.edi_usage_key }}</h4>
                          <v-divider />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </template>
                </v-card>
              </template>
              <v-row>
                <v-col>
                  <div class="overline">
                    住所
                  </div>
                  <h4>
                    〒{{ tenant.zip_code }}&nbsp;{{ tenant.address }}
                  </h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    担当者名
                  </div>
                  <h4>{{ tenant.supervisor_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="6">
                  <div class="overline">
                    担当者名フリガナ
                  </div>
                  <h4>{{ tenant.supervisor_name_kana }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <div class="overline">
                    申込担当者部署名
                  </div>
                  <h4>{{ tenant.supervisor_department_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    申込担当者電話番号
                  </div>
                  <h4>{{ tenant.supervisor_phone_number }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    申込担当者FAX番号
                  </div>
                  <h4>{{ tenant.supervisor_fax_number }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    申込担当者メールアドレス
                  </div>
                  <h4>{{ tenant.supervisor_email }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12" md="3"
                >
                  <div class="overline">
                    正式契約日
                  </div>
                  <h4>{{ tenant.formally_contract_date | date_format }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col
                  cols="12" md="3"
                >
                  <div class="overline">
                    料金プラン
                  </div>
                  <h4>{{ tenant.price_plan_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-divider class="my-4" :thickness="2" color="light-blue lighten-5"></v-divider>
              <v-card-subtitle class="text-h6 font-weight-medium">EDI連携申込Webメール内容</v-card-subtitle>

              <v-row>
                <v-col cols="12" md="12">
                  <div class="overline">
                    メール件名
                  </div>
                  <h4>{{ tenant.mail_templates_attributes && tenant.mail_templates_attributes[0] ? tenant.mail_templates_attributes[0].title : '' }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <div class="overline">
                    メール内容
                  </div>
                  <h4 style="white-space: pre-wrap;">{{ tenant.mail_templates_attributes && tenant.mail_templates_attributes[0] ? tenant.mail_templates_attributes[0].body : '' }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-divider class="my-4" :thickness="2" color="light-blue lighten-5"></v-divider>
              <v-card-subtitle class="text-h6 font-weight-medium">EDI連携申込書</v-card-subtitle>

              <v-row>
                <v-col cols="12" md="12">
                  <v-btn
                    color="primary"
                    @click="outputCFormButtonClickEvent"
                  >
                    EDI WEB申込書ダウンロード（C料金（団体））
                  </v-btn>
                  &nbsp;&nbsp;
                  <v-btn
                    color="primary"
                    @click="outputABFormButtonClickEvent"
                  >
                    EDI WEB申込書ダウンロード（ABC不明料金）
                  </v-btn>
                </v-col>
              </v-row>

              <template
                v-if="useBilling"
              >
                <v-divider class="my-4" :thickness="2" color="light-blue lighten-5"></v-divider>
                <v-card-subtitle class="text-h6 font-weight-medium">請求書設定</v-card-subtitle>

                <v-row>
                  <v-col
                    cols="12" md="6"
                  >
                    <div class="overline">
                      登録番号（適格請求書発行事業者）
                    </div>
                    <h4>{{ tenant.register_number }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12" md="4"
                  >
                    <div class="overline">
                      振込先1
                    </div>
                    <h4>{{ tenant.payee }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="12" md="2"
                  >
                    <div class="overline">
                      口座種別1
                    </div>
                    <h4>{{ tenant.account_type_name }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="12" md="4"
                  >
                    <div class="overline">
                      口座番号1
                    </div>
                    <h4>{{ tenant.account_number }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12" md="12"
                  >
                    <div class="overline">
                      振込口座名義1
                    </div>
                    <h4>{{ tenant.account_name }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12" md="4"
                  >
                    <div class="overline">
                      振込先2
                    </div>
                    <h4>{{ tenant.payee_2 }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="12" md="2"
                  >
                    <div class="overline">
                      口座種別2
                    </div>
                    <h4>{{ tenant.account_type_name_2 }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="12" md="4"
                  >
                    <div class="overline">
                      口座番号2
                    </div>
                    <h4>{{ tenant.account_number_2 }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12" md="12"
                  >
                    <div class="overline">
                      振込口座名義2
                    </div>
                    <h4>{{ tenant.account_name_2 }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12" md="4"
                  >
                    <div class="overline">
                      振込先3
                    </div>
                    <h4>{{ tenant.payee_3 }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="12" md="2"
                  >
                    <div class="overline">
                      口座種別3
                    </div>
                    <h4>{{ tenant.account_type_name_3 }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="12" md="4"
                  >
                    <div class="overline">
                      口座番号3
                    </div>
                    <h4>{{ tenant.account_number_3 }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12" md="12"
                  >
                    <div class="overline">
                      振込口座名義3
                    </div>
                    <h4>{{ tenant.account_name_3 }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12" md="12"
                  >
                    <div class="overline">
                      備考
                    </div>
                    <h4>{{ tenant.note }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
              </template>

              <v-divider class="my-4" :thickness="2" color="light-blue lighten-5"></v-divider>
              <v-card-subtitle class="text-h6 font-weight-medium">数量の確定者</v-card-subtitle>

              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    数量の確定者
                  </div>
                  <h4>{{ tenant.quantity_confirm_name }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>

              <v-divider class="my-4" :thickness="2" color="light-blue lighten-5"></v-divider>
              <v-card-subtitle class="text-h6 font-weight-medium">運搬・処分・最終処分報告通知設定</v-card-subtitle>

              <v-row>
                <v-col cols="12" md="3">
                  <div class="overline">
                    運搬日数
                  </div>
                  <h4>{{ tenant.transport_day }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    処分日数
                  </div>
                  <h4>{{ tenant.disposal_day }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col cols="12" md="3">
                  <div class="overline">
                    最終処分日数
                  </div>
                  <h4>{{ tenant.final_disposal_day }}&nbsp;</h4>
                  <v-divider />
                </v-col>
                <v-col
                  cols="12" md="3"
                >
                  <div class="overline">
                    受注表示期間
                  </div>
                  <h4>{{ tenant.search_start_before_month }}&nbsp;</h4>
                  <v-divider />
                </v-col>
              </v-row>
              <template
                v-if="tenant.use_api && isSuperAdminUser"
              >
                <v-row>
                  <v-col
                    cols="12" md="6"
                  >
                    <div class="overline">
                      APIエンドポイント
                    </div>
                    <h4>{{ tenant.api_endpoint }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="12" md="6"
                  >
                    <div class="overline">
                      APIキー
                    </div>
                    <h4>{{ tenant.api_key }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12" md="6"
                  >
                    <div class="overline">
                      APIクライアントIDキー
                    </div>
                    <h4>{{ tenant.api_client_id_key }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="12" md="6"
                  >
                    <div class="overline">
                      APIシークレットキー
                    </div>
                    <h4>{{ tenant.api_secret_key }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
            <v-divider v-if="tenant.use_api && isSuperAdminUser" />
            <v-card-title v-if="useBilling && tenant.use_freee_claim">
              外部サービス連携
            </v-card-title>
            <v-card-subtitle
              v-if="useBilling && tenant.use_freee_claim"
              class="pt-4 px-4"
            >
              freee請求連携
            </v-card-subtitle>
            <v-card-text>
              <v-row v-if="useBilling && tenant.freee?.linked">
                <v-col
                  cols="12"
                  md="4"
                >
                  <div class="overline">
                    連携中の事業所
                  </div>
                  <template v-if="tenant.freee?.linkage_id">
                    <h4>{{ tenant.freee?.linkage_name }}&nbsp;</h4>
                    <v-divider />
                  </template>
                  <template v-else>
                    <v-btn color="primary" small @click="selectFreeeCompanyButtonClickEvent">
                      事業所を選択
                    </v-btn>
                  </template>
                </v-col>
                <v-col cols="12" md="8" class="text-right">
                  <v-btn
                    color="error"
                    @click="enableCancelLinkageConfirmDialog = true"
                  >
                    連携解除
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="useBilling && tenant.use_freee_claim && !tenant.freee?.linked">
                <v-col>
                  <v-btn
                    color="primary"
                    small
                    @click="freeeLinkageButtonClickEvent"
                  >
                    設定する
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="editButtonClickEvent"
            >
              編集
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </div>

    <v-dialog
      v-model="enableCancelLinkageConfirmDialog"
      width="500"
      @keydown.esc="cancelButtonClickEvent"
      @close="cancelButtonClickEvent"
    >
      <v-card>
        <v-toolbar dark flat color="error">
          <v-toolbar-title>確認</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <h3 class="my-5 font-weight-thin">連携を解除してよろしいですか？</h3>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            elevation="1"
            @click="cancelButtonClickEvent"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="error"
            @click="cancelLinkageButtonClickEvent"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  name: 'DriverTenantForm',
  components: {
  },
  mixins: [],
  data () {
    return {
      contractor: null,
      tenant: null,
      enableCancelLinkageConfirmDialog: false,
      external_error: null,
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      useBilling: 'use_billing',
    }),
    ...mapGetters('DriverAuthentication', [
      'isSuperAdminUser',
    ]),
  },
  created() {
    const query = this.$route.query
    // 外部サービス連携 コールバック処理からの戻りにエラーを表すパラメータが付与されている場合の処理
    if (query.error) {
      this.external_error = query.error
    }

    this.loader()
  },
  methods: {
    ...mapActions('DriverMasterTenant', {
      fetchTenant: 'show',
    }),
    ...mapActions("DriverProvider", {
      destroyProvider: "destroy",
    }),
    ...mapActions("DriverProviderSetting", {
      reflection: "reflection",
    }),
    editButtonClickEvent () {
      this.$router.push({name: 'DriverMasterTenantEdit'})
    },
    /**
     * freee連携 設定するボタン クリックイベント
     */
    freeeLinkageButtonClickEvent () {
      // stateの発行
      const state = Array.from({ length: 20 }, () => Math.random().toString(36)[2]).join('');
      const client_id = process.env.VUE_APP_FREEE_CLIENT_ID
      const redirect_uri = encodeURIComponent(`${process.env.VUE_APP_DRIVER_URL}/providers/freee/callback`)
      this.reflection({params: { state: state }}).then(() => {
        location.href = `https://accounts.secure.freee.co.jp/public_api/authorize?response_type=code&client_id=${client_id}&redirect_uri=${redirect_uri}&state=${state}`
      })
    },
    cancelButtonClickEvent () {
      this.enableCancelLinkageConfirmDialog = false;
    },
    /**
     * freee請求連携 連携解除ボタン クリックイベント
     */
    cancelLinkageButtonClickEvent () {
      this.destroyProvider({ provider: 'freee' }).then(() => {
        this.loader();
        this.enableCancelLinkageConfirmDialog = false
      })
    },
    selectFreeeCompanyButtonClickEvent () {
      this.$router.replace({name: 'DriverProviderFreeeCompany'})
    },
    /**
     * C料金用申込書出力ボタン クリックイベント
     * @description 受渡確認票を別タブにて表示する
     */
    outputCFormButtonClickEvent() {
      let resolvedRoute = this.$router.resolve({
        name: "DriverJwnetJoinApplicationForms",
      });
      window.open(resolvedRoute.href, "_blank");
    },
    /**
     * AB料金用申込書出力ボタン クリックイベント
     * @description 受渡確認票を別タブにて表示する
     */
    outputABFormButtonClickEvent() {
      let resolvedRoute = this.$router.resolve({
        name: "DriverJwnetEdiApplicationForms",
      });
      window.open(resolvedRoute.href, "_blank");
    },
    loader () {
      this.fetchTenant().then((content) => {
        this.tenant = content.tenant
        this.contractor = content.contractor
        if (this.tenant.freee?.linked && !this.tenant.freee?.linkage_id) {
          this.external_error = 'company_unselected'
        }
      })
    },
  }
}
</script>
